import consumer from "./consumer"

consumer.subscriptions.create("UserChannel", {
  connected() {
    console.log('connected to user')
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    $('#notifications').html(data.html);
  }
});
